import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { profilingService } from '../../services/api';

// État initial
const initialState = {
  profileAnalysis: null,
  emailResults: null,
  loading: false,
  error: null,
  analysisInProgress: false,
  emailInProgress: false
};

// Actions asynchrones
export const analyzeProfile = createAsyncThunk(
  'profiling/analyzeProfile',
  async ({ kidId, answers, ageSectionId }, { rejectWithValue }) => {
    try {
      const response = await profilingService.analyze(kidId, answers, ageSectionId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const sendProfileResults = createAsyncThunk(
  'profiling/sendProfileResults',
  async ({ kidId }, { rejectWithValue }) => {
    try {
      const response = await profilingService.sendResults(kidId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Slice
const profilingSlice = createSlice({
  name: 'profiling',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearAnalysis: (state) => {
      state.profileAnalysis = null;
      state.emailResults = null;
    },
    setAnalysisInProgress: (state, action) => {
      state.analysisInProgress = action.payload;
    },
    setEmailInProgress: (state, action) => {
      state.emailInProgress = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Analyze profile
      .addCase(analyzeProfile.pending, (state) => {
        state.loading = true;
        state.analysisInProgress = true;
        state.error = null;
      })
      .addCase(analyzeProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.analysisInProgress = false;
        state.profileAnalysis = action.payload.profile;
        state.error = null;
      })
      .addCase(analyzeProfile.rejected, (state, action) => {
        state.loading = false;
        state.analysisInProgress = false;
        state.error = action.payload;
      })

      // Send profile results
      .addCase(sendProfileResults.pending, (state) => {
        state.loading = true;
        state.emailInProgress = true;
        state.error = null;
      })
      .addCase(sendProfileResults.fulfilled, (state, action) => {
        state.loading = false;
        state.emailInProgress = false;
        state.emailResults = action.payload;
        state.error = null;
      })
      .addCase(sendProfileResults.rejected, (state, action) => {
        state.loading = false;
        state.emailInProgress = false;
        state.error = action.payload;
      });
  }
});

export const {
  clearError,
  clearAnalysis,
  setAnalysisInProgress,
  setEmailInProgress
} = profilingSlice.actions;

export default profilingSlice.reducer;
